module.exports = __webpack_public_path__ + "img/brand-icons.a1a749e8.65363c4d.svg";